/*
 * Tenue — deferred-media.js
 * Loads videos and 3D models when buyers ask for them.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     <deferred-media>: loads a video or 3D model when requested.
     ------------------------------------------------------------------------ */
  if (!customElements.get('deferred-media')) {
    class DeferredMedia extends HTMLElement {
      connectedCallback() {
        const trigger = this.querySelector('[data-deferred-trigger]');
        if (trigger) trigger.addEventListener('click', () => this.load(true));
      }

      load(focus) {
        if (this.getAttribute('loaded') !== null) return;
        const template = this.querySelector('template');
        if (!template) return;
        document.querySelectorAll('deferred-media[loaded]').forEach((media) => {
          if (media !== this && typeof media.pause === 'function') media.pause();
        });
        const content = document.createElement('div');
        content.appendChild(template.content.firstElementChild.cloneNode(true));
        const element = content.firstElementChild;
        this.setAttribute('loaded', '');
        this.appendChild(element);
        const trigger = this.querySelector('[data-deferred-trigger]');
        if (trigger) trigger.hidden = true;
        if (focus && element.focus) element.focus();
        if (element.nodeName === 'VIDEO' && element.play) element.play().catch(() => {});
        if (element.nodeName === 'MODEL-VIEWER' && window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: (errors) => {
                if (errors || !window.Shopify.ModelViewerUI) return;
                this.modelViewerUI = new window.Shopify.ModelViewerUI(element);
              },
            },
          ]);
        }
      }

      pause() {
        const iframe = this.querySelector('iframe');
        const video = this.querySelector('video');
        if (video) video.pause();
        if (!iframe) return;
        const src = iframe.getAttribute('src') || '';
        if (src.includes('youtube')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (src.includes('vimeo')) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      }
    }
    customElements.define('deferred-media', DeferredMedia);
  }
})();
